import loadable from '@loadable/component';

import { WithCollapse } from '../WithCollapse';

/* istanbul ignore next */
export const NewbuildingMortgageSectionLoadable = loadable(() => import('./NewbuildingMortgageSectionContainer'));

/* istanbul ignore next */
export const NewbuildingMortgageSectionWithCollapse = WithCollapse({
  WrappedComponent: NewbuildingMortgageSectionLoadable,
});
